/**
 * Type registry — maps server-defined metaModel.type names to Vue components.
 *
 * This is the second resolution phase in FieldResolver: if no widget-based
 * match was found, the field's base type (string, number, boolean, etc.)
 * is looked up here. This is the fallback for fields without a specialized widget.
 *
 * Type resolvers can also route specific fields to specialized components
 * (e.g. the 'string' resolver sends the 'id' field to ItemLink instead of StringView).
 */
const types = new Map()

/**
 * Register a type resolver.
 * @param {string} name - matches metaModel.type from server metadata (e.g. 'string', 'number')
 * @param {function} resolver - (context) => Component | null
 *   context: { page, editable, isEditMode, metaModel }
 */
export function registerType(name, resolver) {
  // import.meta.hot is Vite's HMR API — truthy during hot-reload. Suppress
  // the warning when HMR re-executes this module (re-registration is expected).
  if (types.has(name) && !import.meta.hot) {
    console.warn(`[typeRegistry] Overwriting existing type: ${name}`)
  }
  types.set(name, resolver)
}

/**
 * Resolve a type by name.
 * @returns Component | null
 */
export function resolveType(name, context) {
  const resolver = types.get(name)
  if (!resolver) return null
  return resolver(context)
}

export function hasType(name) {
  return types.has(name)
}

export function getRegisteredTypes() {
  return Array.from(types.keys())
}
